/**
 * Side effects that must run during a user gesture when entering a call route.
 * Meet/Zoom pattern: acquire live mic/camera under the tap, then place/answer.
 */

import { acquireCallAudioSession } from './callAudioSessionPolicy';
import { normalizeCallMediaKind } from './callMediaConstraints';
import { acquireCallMediaCapture } from './callMediaCaptureService';
import {
  CALL_RINGTONE_VARIANT,
  stopCallRingtoneLoop,
} from './callRingtoneService';

/**
 * Outgoing Start Call — run inside the click/tap handler before navigation.
 * @param {'voice'|'video'|string} callKind
 */
export async function bootstrapOutgoingCallRoute(callKind) {
  // Call Again must silence a leftover incoming ping before we switch to capture.
  stopCallRingtoneLoop({ restoreSession: false });
  acquireCallAudioSession();
  return acquireCallMediaCapture(normalizeCallMediaKind(callKind));
}

/**
 * Incoming Answer — stop speaker ringtone, switch to PlayAndRecord, acquire media.
 * @param {'voice'|'video'|string} callKind
 */
export async function bootstrapIncomingCallAnswer(callKind) {
  // Stop MP3 ring first; do not restore ambient — capture epoch starts next.
  stopCallRingtoneLoop({ restoreSession: false, variant: CALL_RINGTONE_VARIANT.INCOMING });
  acquireCallAudioSession();
  return acquireCallMediaCapture(normalizeCallMediaKind(callKind));
}
